<ng-container>
  <div class="progress" *ngIf="project && project.completion < 100">
    <div class="progress-bar progress-bar-striped progress-bar-animated" [style.width.%]="project.completion">
      <div class="progress-percent-container">
      <p> {{project.completion}}% </p>
    </div>
    </div>
  </div>
</ng-container>